var map = {
	"./bookkeeping.svg": "e213",
	"./card.svg": "d3f0",
	"./cardMonitoring.svg": "059c",
	"./chart-square.svg": "9d3e",
	"./download.svg": "75b0",
	"./gwt-icon.svg": "42ba",
	"./home.svg": "362b",
	"./insights.svg": "07c5",
	"./invoice.svg": "cd3e",
	"./money.svg": "8be56",
	"./online-store.svg": "87ff",
	"./personalcard.svg": "df62",
	"./pos.svg": "cdb1",
	"./products.svg": "3387",
	"./profile-2user.svg": "3165",
	"./security.svg": "20f8",
	"./settings.svg": "74f1",
	"./support.svg": "d190",
	"./terminals.svg": "6905",
	"./tickets.svg": "5c73",
	"./tractionaccount.svg": "6734",
	"./transactions.svg": "fb27"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6dd8";